import { PermissionActions } from '@/features/permissions/permissionActions.js'

export const dashboardRoutes = [
  {
    path: 'dashboard',
    component: () => import('@/features/dashboard/AdminDashboardView.vue'),
    meta: { permissionAction: PermissionActions.DashboardView },
  },
  {
    path: 'dashboard/organization/club/:clubId',
    component: () =>
      import('@/features/dashboard/organization/byClubReport/DashboardOrgByClubReport.vue'),
    meta: { permissionAction: PermissionActions.DashboardView },
  },
]
